import React from 'react';
import { PrimaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';

const SelectScenarioButton = ({
  buttonLabel,
  onConfirm,
  loading,
  disabled,
}) => {
  return (
    <PrimaryActionButton
      loading={loading}
      disabled={disabled}
      label={buttonLabel}
      onClick={onConfirm}
    />
  );
};

export default SelectScenarioButton;

SelectScenarioButton.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};
